window.addEventListener('load', function () {
    const element = document.querySelector('.productFinder');
    if (element) {

        // tooltips for productFinder
        tippy.delegate('.steps', { target: '.tooltip' });

        const stepContainer = element.querySelector('.steps');
        const resultsContainer = element.nextElementSibling;
        let progress = '';

        // check if button.previous or button.next button was clicked and set the value of progress var accordingly
        stepContainer.addEventListener('click', function (event) {
            if (event.target.classList.contains('previous')) {
                progress = 'previous';
            } else if (event.target.classList.contains('next') || event.target.classList.contains('submit')) {
                progress = 'next';
            }
        });

        // check if inputs with name skin_type[] are checked and enable or disable the next button accordingly
        stepContainer.addEventListener('change', function (event) {
            if (event.target.name === 'skin_type[]') {
                let nextButton = stepContainer.querySelector('.next');
                let checkedInputs = stepContainer.querySelectorAll('input[name="skin_type[]"]:checked');
                if (checkedInputs.length > 0) {
                    nextButton.classList.remove('disabled');
                } else {
                    nextButton.classList.add('disabled');
                }
            }
        });

        // on form submit prevent default and call productFinderStep() with next or previous step
        stepContainer.addEventListener('submit', function (event) {
            event.preventDefault();
            // if clicked button has class disabled, return
            if (event.submitter.classList.contains('disabled')) {
                event.submitter.closest('form').querySelector('.required').classList.remove('hidden');
                return;
            }

            // if clicked button has class reset trigger ajax reset action
            if (event.submitter.classList.contains('reset')) {
                productFinderReset();
                return;
            }

            productFinderStep();
        });

        function productFinderStep () {

            let form = stepContainer.querySelector('form');
            let inner = stepContainer.closest('.inner');
            let actStepNumber = inner.querySelector('.progress .act');
            let lastStepNumber = parseInt(inner.querySelector('.progress .last').innerHTML);

            inner.classList.add('loading');

            if( progress === 'next' ) {
                animateTo = -100;
                animateFrom = 100;
            } else if( progress === 'previous' ) {
                animateTo = 100;
                animateFrom = -100;
            }

            gsap.to(stepContainer.querySelectorAll('.content, .image'), {autoAlpha: 0, x: animateTo});

            // make ajax call with form data to '/wp-admin/admin-ajax.php', action 'product_finder_step'
            // on success, replace the content of the productFinder div with the json response

            var request = new XMLHttpRequest();
            var formData = new FormData(form);

            var step = formData.get('step').toString().trim();
            var parsedStepValue = /^\d+$/.test(step) ? parseInt(step) : 0;

            if (parsedStepValue <= 0) {
                parsedStepValue = 0;
            }

            formData.set('step', parsedStepValue);

            var goToStep = parsedStepValue;
            if (progress === 'next') {
                goToStep++;
            } else if (progress === 'previous') {
                goToStep--;
            }

            if (goToStep < 0) {
                goToStep = 0;
            }

            formData.set('goToStep', goToStep);

            // log formData for debugging
            //for (var [key, value] of formData.entries()) {
            //     console.log(key + ': ' + value);
            //}

            request.open('POST', '/wp-admin/admin-ajax.php', true);
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
            request.onload = function () {
                if (this.status >= 200 && this.status < 400) {
                    // If successful
                    const response = JSON.parse(this.response);
                    var goTo = parseInt(response.goToStep);

                    stepContainer.innerHTML = response.stepContainer;

                    if(goTo !== lastStepNumber) {

                        gsap.from(stepContainer.querySelectorAll('.content, .image'), {autoAlpha: 0, x: animateFrom});

                        // update progress act step number, add 1 because the step number is 0 based
                        actStepNumber.innerHTML = goTo + 1;

                        // calc progress bar width, calc based on the number of steps
                        let width = (goTo + 1) / lastStepNumber * 100;

                        // update progress bar width, calc based on the number of steps
                        gsap.to(inner.querySelector('.bar'), {width: width + '%'});

                        // wait for the animation to finish before removing the loading class
                        //setTimeout(function () {
                            inner.classList.remove('loading');
                        //}, 700);

                    } else {

                        inner.classList.remove('loading');
                        // hide progress bar
                        inner.querySelector('.pagination').classList.add('hidden');

                        // after timeline is finished, remove the productFinder element and show the results
                        let tl = gsap.timeline(
                            {
                                onComplete: function () {
                                    if(response.resultsContainer) {
                                        // add resultsContainer HTML to the DOM behind the productFinder element
                                        element.insertAdjacentHTML('afterend', response.resultsContainer);

                                        // add resultsVisible class to the productFinder element
                                        element.classList.add('resultsVisible');

                                        // reinit swiper for all added relatedProductsSlider elements
                                        if (sliders = getElements(document.querySelectorAll('.relatedProductsSlider'))) {
                                            sliders.forEach(function(element) {
                                                initRelatedProductsSlider(element);
                                            });
                                        }
                                    }
                                }
                            }
                        );

                        tl
                            .from(stepContainer.querySelectorAll('.calculatingResult svg.crystal'), {autoAlpha: 0, y: 20})
                            .from(stepContainer.querySelectorAll('.calculatingResult .headline'), {autoAlpha: 0, y: 20})
                            .from(stepContainer.querySelectorAll('.calculatingResult .description'), {autoAlpha: 0, y: 20}, "-=0.5")
                            .to(stepContainer.querySelectorAll('.calculatingResult path.crystal'), {duration: 1, rotation: 360, transformOrigin: '50% 50%', ease: 'power2.inOut', repeat: 3, yoyo: true}, 0)
                            .to(stepContainer.querySelectorAll('.calculatingResult svg.crystal, .calculatingResult .headline, .calculatingResult .description'), {autoAlpha: 0, y:20, duration: 0.5}, 3)
                            .from(stepContainer.querySelectorAll('.resultDescription h3'), {autoAlpha: 0, y: 20})
                            .from(stepContainer.querySelectorAll('.resultDescription .description'), {autoAlpha: 0, y: 20}, "-=0.5")
                            .from(stepContainer.querySelectorAll('.resultDescription .button'), {autoAlpha: 0, y: 20}, "-=0.5")
                        ;
                    }

                } else {
                    // If fail
                    console.log('failed response: ', this.response);
                }
            };
            request.onerror = function() {
                // Connection error
                console.log('connection error: ', this.response);
            };
            request.send('action=product_finder_step&' + new URLSearchParams(formData).toString());

        }

        function productFinderReset () {

            let form = stepContainer.querySelector('form');

            var request = new XMLHttpRequest();
            var formData = new FormData(form);

            request.open('POST', '/wp-admin/admin-ajax.php', true);
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
            request.onload = function () {
                if (this.status >= 200 && this.status < 400) {
                    // If successful reload the page
                    location.reload();
                    console.log('success response: ', this.response);
                } else {
                    // If fail
                    console.log('failed response: ', this.response);
                }
            }
            request.onerror = function() {
                // Connection error
                console.log('connection error: ', this.response);
            }
            request.send('action=product_finder_reset&' + new URLSearchParams(formData).toString());
        }

    }
});
